import classNames from "classnames";
import React from "react";
import { CSSTransition } from "react-transition-group";
import "./ModalComponent.scss";

const ModalComponent = ({
  onCloseModal,
  isVisible,
  size = 'md',
  children,
  text = "basic"
}) => {
  const handleCloseModal = (e) => {
    if (
      [...e.target.classList].includes(`modalcomponent__${text}`)
      || [...e.target.classList].includes(`modalcomponent__close__${text}`)
    ) {
      onCloseModal?.();
    }
  };

  return (
    <>
      <CSSTransition
        in={!!isVisible}
        timeout={150}
        unmountOnExit
        classNames="modalcomponent"
      >
        <div
          className={`modalcomponent modalcomponent__${text}`}
          onClick={handleCloseModal}
        >
          <div
            className={classNames({
              "modalcomponent__container": true,
              "modalcomponent__container--md": size === 'md',
              "modalcomponent__container--sm": size === 'sm',
              "modalcomponent__container--sm-md": size === 'sm-md',
            })}
          >
            <button
              className={`modalcomponent__close modalcomponent__close__${text}`}
              onClick={handleCloseModal}
            >
              &times;
            </button>

            {children}
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default ModalComponent;
